export function arrayDiff(a: any[], b: any[]): any[] {
  const removeDuplicate = (arr: number[]) => [...new Set(arr)];
  const newUsersIdFiltered = a?.filter((item) => b?.indexOf(item) < 0);
  const oldUsersIdFiltered = b?.filter((item) => a?.indexOf(item) < 0);
  return removeDuplicate([...newUsersIdFiltered, ...oldUsersIdFiltered]);
}
